import { render, staticRenderFns } from "./viewJob.vue?vue&type=template&id=1a8416b1&scoped=true"
import script from "./viewJob.vue?vue&type=script&lang=js"
export * from "./viewJob.vue?vue&type=script&lang=js"
import style0 from "./viewJob.vue?vue&type=style&index=0&id=1a8416b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8416b1",
  null
  
)

export default component.exports